import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Select,
  Spin,
} from "../../common/utils/antd-imports/AntdImports";
import "../float-input/FloatInput.css";
import { ReactComponent as SelectUpIcon } from "../../../assests/select-up-icon.svg";
import { ReactComponent as SelectDownIcon } from "../../../assests/select-down-icon.svg";
const { Option } = Select;

const FloatingSelect = ({
  label,
  size = "middle",
  isChannels = false,
  width = "100%",
  loading = false,
  options = [],
  isDma = false,
  isMultipleProduct = false,
  customStyles = {},
  isRequired,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [hasValue, setHasValue] = useState(!!props.value);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setHasValue(!!props.value);
  }, [props.value]);
  const getTextFromReactNode = (node) => {
    if (typeof node === "string") return node;
    if (Array.isArray(node)) return node.map(getTextFromReactNode)?.join("");
    if (node?.props?.children) return getTextFromReactNode(node.props.children);
    return "";
  };
  return (
    <div
      className={`floating-input-container ${size}`}
      style={{
        width,
        position: "relative",
        ...customStyles,
      }}
    >
      {(isFocused || hasValue) && (
        <label
          className={`floating-label focused`}
          style={{
            "--label-font-size": customStyles["--label-font-size"] || "66px",
            "--label-focused-font-size":
              customStyles["--label-focused-font-size"] || "12px",
            "--label-color": customStyles["--label-color"] || "#333333",
            "--label-focused-color":
              customStyles["--label-focused-color"] || "#f10c0c",
            "--label-focused-top": customStyles["--label-focused-top"] || "0px",
            "--label-focused-z-index":
              customStyles["--label-focused-z-index"] || 0,
            paddingLeft: customStyles["--label-padding-left"] || 0,
          }}
        >
          {label}
          {isRequired && <span style={{ color: "#d2042d" }}> *</span>}
        </label>
      )}
      <Select
        {...props}
        size={size}
        value={props.value}
        popupClassName="billboard-select-dropdown"
        notFoundContent={
          loading ? (
            <Spin size="small" className="common-spin-floating-select" />
          ) : null
        }
        onDropdownVisibleChange={(open) => setIsOpen(open)}
        placeholder={
          !isFocused
            ? getTextFromReactNode(label) + (isRequired ? "*" : "")
            : ``
        }
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        loading={loading}
        allowClear
        suffixIcon={isOpen ? <SelectUpIcon /> : <SelectDownIcon />}
        style={{
          "--input-border-color":
            customStyles["--input-border-color"] || "#333333",
          "--input-border-color-focused":
            customStyles["--input-border-color-focused"] || "#0c0c0c",
          fontWeight: customStyles["--input-font-weight"] || 400,
          paddingTop: customStyles["--input-padding-top"] || 0,
        }}
        optionRender={
          isMultipleProduct
            ? (option) => (
                <Checkbox checked={props.value?.includes(option.value)}>
                  {option.label}
                </Checkbox>
              )
            : undefined
        }
        options={
          isMultipleProduct
            ? options?.map((option) => ({
                label: option.name,
                value: option.id || option.name,
              }))
            : isDma
              ? options
              : undefined
        }
      >
        {!isMultipleProduct &&
          !isDma &&
          options?.map((option) => (
            <Option
              key={option.id}
              value={isChannels ? option.id : option.name}
            >
              {option.name}
            </Option>
          ))}
      </Select>
    </div>
  );
};

export default FloatingSelect;
